import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class ContractExternalFieldService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ci/contractExternalFields')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-table-cells';
    }

    getObjectLabels(): string[] {
        return ['satzart', 'fieldName', 'fieldValue'];
    }

}
